import { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import { PersonaCollection } from '@sdk/personaCollection/types/PersonaCollection';
import { UserFromApi } from '@sdk/users/types/UserFromApi';
import mapUserFromApi from '@sdk/users/utils/mapUserFromApi';

import { isDeletedUserFromApi } from '@web/guards/isDeletedUserFromApi';

interface PersonaFromAPI {
  id: number;
}

// regular users are plain ID objects and they are pulled form personasDict
// deleted users are full objects in the response and they are not present in personasDict
export function getPersonaFromAPI<T extends PersonaFromAPI, U>(
  persona: T,
  personaCollection: PersonaCollection,
  currentUser: AuthUserType
) {
  const { personasDict: personas } = personaCollection;
  let messageUser = persona && personas[persona.id] ? personas[persona.id] : persona;
  if (isDeletedUserFromApi(persona)) {
    const groupIds = persona.groupIds || [];
    messageUser = mapUserFromApi({ ...persona, groupIds } as UserFromApi, currentUser, personas);
  }

  return messageUser as unknown as U;
}
